module.exports = __webpack_public_path__ + "static/img/varanasi.ee675bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/varanasi.jpg
// module id = 0ovn
// module chunks = 1